import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DeviceService, EventTrackerService, HttpService} from '@app/core';
import {IndicatorService} from '@app/shared';
import {environment} from '@env/environment';

import {carouselEnum} from './iCarousel';
import {ISubscriptionStatus} from "@app/app/library/iModelSummary";
import {NavigationBarService} from "@app/shared/navigation-bar/navigation-bar.service";
import {PlayerService} from "@app/components/player/player.service";
import {PDPService} from "@app/app/pdp/pdp/pdp.service";
import {AppParametersService} from "@app/core/token/app-parameters.service";
import {NavigationBarEnum} from "@app/shared/navigation-bar/navigation-bar.model";

@Component({
  selector: "navaar-carousel",
  templateUrl: "./carousel.component.html",
  styleUrls: ["./carousel.component.scss"],
})
export class CarouselComponent implements OnInit {
  @Input() public title;
  @Input() public typeOfCarousel: carouselEnum;
  @Input() items;
  @Input() listsCollection: Array<any>;
  @Input('name-tracker-event') private nameTrackerEvent: string;
  @Input('index-carousel') private indexCarousel: number;
  @Input("rate-style") public rateStyle: object;
  @Input("type-url") public typeUrl: string;
  @Input("is-direct-play") public isDirectPlay: boolean = false;
  @Input("is-route-to-pdp-isOwner-false") public isRouteToPdpIsOwnerFalse: boolean = false;
  @Input("identifier") public identifier: number;
  @Input("disable-route-show-all") public disableRouteShowAll: boolean = false;
  @Input("show-rate") public showRate: boolean;
  @Input("badge-type") public BadgeType;
  @Input("is-check-status-subscription") public isCheckStatusSubscription: boolean = false;
  @Input("show-context-menu-icon") public showContextMenuIcon: boolean = false;
  @Output("onClick-show-context-menu-icon") public onClickShowContextMenuIcon: EventEmitter<{ identifier: number, audiobookId: string, title: string, subscriptionStatus: ISubscriptionStatus, isOwner: boolean | null }> = new EventEmitter<{ identifier: number, audiobookId: string, title: string, subscriptionStatus: ISubscriptionStatus, isOwner: boolean | null }>();
  @Input("style-show-all") public styleShowAll: "blue" | "grey" | "no-icon" | "grey-icon" | "yellow";
  @Output("onClick-show-all") public clickedShowAll: EventEmitter<any> = new EventEmitter<any>();
  @Output("onClick-item") public clickeditem: EventEmitter<any> = new EventEmitter<any>();
  public isNewDevices: boolean = true;

  public carousel: typeof carouselEnum = carouselEnum;
  public readonly BASE_HREF_IMAGE = environment.imageUrl;

  constructor(
    public readonly device: DeviceService,
    private readonly indicator: IndicatorService,
    private readonly chkd: ChangeDetectorRef,
    private readonly activatedRoute: ActivatedRoute,
    public readonly eventTracker: EventTrackerService,
    private readonly router: Router,
    private readonly http: HttpService,
    private readonly navigationBarService: NavigationBarService,
    private readonly playService: PDPService,
    private readonly parameterService: AppParametersService
  ) {
  }

  ngOnInit(): void {
    if (this.device.isAndroid())
      this.isNewDevices = this.device.compareVersions(this.device.osVersion(), '>', '4.4.0');
  }

  public goToList() {
    this.clickedShowAll.emit();
    if (this.disableRouteShowAll)
      return;
    this.analyticsEventBtnShowAll();
    if (this.identifier) {
      this.router.navigate(["../list", this.identifier], {
        queryParams: {title: this.title, keyUrl: this.typeUrl},
        relativeTo: this.activatedRoute,
      }).then();
    } else {
      this.router.navigate(["../list"], {
        queryParams: {title: this.title, keyUrl: this.typeUrl},
        relativeTo: this.activatedRoute,
      }).then();
    }
  }

  public goToArtistPage(id) {
    this.indicator.show();
    this.router.navigate(['/artist', id]).then();
  }

  public goToPublisherPage(id) {
    this.indicator.show();
    this.router.navigate(['/publisher', id]).then();
  }

  public navigate(identifier, title, item = null) {
    if (this.isRouteToPdpIsOwnerFalse){
      if (item.isOwner === false) {
        this.router.navigate(["/pdp", identifier], {
          relativeTo: this.activatedRoute,
        }).then(() => this.navigationBarService.activeMenu = NavigationBarEnum.vitrin);
        return;
      }
    }
    if (item?.subscriptionStatus != null ? (item.subscriptionStatus?.isSubscriptionConsumption && item.subscriptionStatus?.isExpired) : false) {
      this.parameterService.isShowMessageEndSubscription = true;
      return;
    }
    if (this.isDirectPlay) {
      this.indicator.showHude();
      this.playService.playWithIdentifierId(identifier, this.isDirectPlay).then(x => this.indicator.hideHude());
    } else
      this.router.navigate(["/pdp", identifier], {
        relativeTo: this.activatedRoute,
      }).then();
  }

  public trackByFn(i, item) {
    return i;
  };

  public analyticsEvent(identifier, title, index) {
    this.eventTracker.logEvent(this.nameTrackerEvent, {
      x_source_item_id: this.identifier,
      x_dest_item_id: identifier,
      "title-slider": this.title,
      x_dest_item_title: title,
      x_source_index: this.indexCarousel,
      x_item_index: index,
      x_type_carousel: carouselEnum[this.typeOfCarousel]
    });
  }

  public analyticsEventBtnShowAll() {
    this.eventTracker.logEvent(this.nameTrackerEvent + '_btn_show_all', {
      x_source_item_id: this.identifier,
      "title-slider": this.title,
      x_source_index: this.indexCarousel,
      x_type_carousel: carouselEnum[this.typeOfCarousel]
    });
  }

  public goTocatagory(a, b) {
    this.indicator.show();
    this.chkd.detectChanges();
    this.router.navigate([a], {queryParams: b}).then();
  }

  public onShowContextMenu($event, identifier, audiobookId, title, subscriptionStatus: ISubscriptionStatus, isOwner) {
    $event.stopPropagation();
    this.onClickShowContextMenuIcon.emit({identifier, audiobookId, title, subscriptionStatus, isOwner});
    return false;
  }
}
